import { GridProps } from "@mui/material";
import { SimpleFormProps } from "react-admin";

import FormGridContainer from "./FormGridContainer";
import SimpleBoxForm from "./SimpleBoxForm";

type GridFormProps = SimpleFormProps & {
  grid?: GridProps;
};

export default function SimpleGridForm(props: GridFormProps) {
  const { children, grid = {}, ...formProps } = props;

  return (
    <SimpleBoxForm {...formProps}>
      <FormGridContainer {...grid}>{children}</FormGridContainer>
    </SimpleBoxForm>
  );
}
